import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Alert, Box, Chip, CircularProgress, Stack, Tooltip, Typography,
} from '@mui/material';
import HubIcon from '@mui/icons-material/Hub';
import FunctionsIcon from '@mui/icons-material/Functions';

import { fetchRequest as fetchDrivers } from '../../redux/actions/discovery/fleetDrivers';
import RelationshipGraph from './RelationshipGraph';
import { useDisplayNames } from '../../utils/displayNames';

const FleetDriversPanel = ({ goalId, drivers, driversFetch }) => {
  const nameOf = useDisplayNames();
  useEffect(() => { driversFetch({ goalId }); }, [goalId, driversFetch]);

  const data = drivers?.response;

  return (
    <Stack spacing={2}>
      <Box>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
          <HubIcon fontSize="small" color="primary" />
          <Typography variant="subtitle2" fontWeight={700}>Driver Discovery</Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          What moves the fleet average. Validated drivers are injected into every member&rsquo;s score.
        </Typography>
      </Box>

      {drivers?.error && <Alert severity="error">{String(drivers.error)}</Alert>}
      {drivers?.isLoading && !data ? (
        <Stack alignItems="center" sx={{ py: 4 }}><CircularProgress size={22} /></Stack>
      ) : data && (
        <>
          <Box>
            <Stack direction="row" alignItems="center" spacing={0.75} sx={{ mb: 0.75 }}>
              <FunctionsIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="overline" color="text.secondary">
                Shared covariates in member scoring
              </Typography>
            </Stack>
            {data.covariates?.length ? (
              <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
                {data.covariates.map((k) => (
                  <Tooltip key={k} title={k} arrow>
                    <Chip size="small" label={nameOf(k)} />
                  </Tooltip>
                ))}
              </Stack>
            ) : (
              <Typography variant="caption" color="text.secondary">
                None yet — they appear once discovery validates the first drivers.
              </Typography>
            )}
          </Box>

          {data.companion_goal_id ? (
            data.companion_status && ['serving', 'live', 'idle'].includes(data.companion_status) ? (
              <RelationshipGraph goalId={data.companion_goal_id} />
            ) : (
              <Alert severity="info">
                Discovery is still running — the graph appears when it settles.
              </Alert>
            )
          ) : (
            <Alert severity="info">
              Discovery starts with the first scoring run.
            </Alert>
          )}
        </>
      )}
    </Stack>
  );
};

const mapStateToProps = (state) => ({
  drivers: state.discovery_fleet_drivers,
});

const mapDispatchToProps = (dispatch) => ({
  driversFetch: (payload) => dispatch(fetchDrivers(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FleetDriversPanel);
